var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-button',{attrs:{"small":"","secondary":"","color":_vm.color,"title":_vm.$t('go_back'),"text":_vm.$t(_vm.text),"icon-left":"prev","to":_vm.to},on:{"click":function($event){$event.preventDefault();return _vm.onButtonClick(_vm.force)}}})}
var staticRenderFns = []

export { render, staticRenderFns }